import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getRefundDetail } from '../refundsEndpoints'
import { refundKeys } from '../refundsQueryKeys'

export function useRefundDetailQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => refundKeys.detail(toValue(id)),
    queryFn: () => getRefundDetail(toValue(id)),
    enabled: () => !!toValue(id),
  })
}
